import { Vue3Marquee } from 'vue3-marquee';
import 'vue3-marquee/dist/style.css';
import { mapMutations, mapState } from 'vuex';
export default {
  components: {
    Vue3Marquee
  },
  props: ["musicList", "isbtnShow", "playMusic", "addDuration", "updateAudioCtime"],
  setup(props) {
    // console.log(props);
  },
  updated() {
    this.addDuration();
  },
  // mounted(){
  //     this.addDuration()

  // },
  watch: {
    // musicList() {        // 在点击切换歌曲时。 去获取歌词的信息
    // $store.dispatch触发vuex里的异步action
    // this.$store.dispatch("getLyric", this.musicList.id)
    // 获取歌曲的总时长
    // },
    // 监听歌词播放的时间，来实现歌词随着唱而滚动
    currentTime(newValue) {
      // 获取p标签中绑定了active类的元素，即当前正在唱的那句歌词
      let p = document.querySelector("p.active");
      // console.log([p]);
      // 如果offset超过300了就要开始调整滚动条的位置，让正在唱的歌词始终处于中间位置
      if (p && p.offsetTop > 300) {
        this.$refs.musicLyric.scrollTop = p.offsetTop - 300;
      }
      // 如果当前的播放时长大于等于总时长,就向下切歌
      if (newValue == this.duration) {
        this.switchSong(1);
      }
      // console.log(this.$refs.musicLyric.offsetTop);
    }
  },

  computed: {
    ...mapState(["lyricList", "currentTime", "playListIndex", "playList", "duration"]),
    // 切割处理歌词数据
    lyric() {
      let arr;
      if (this.lyricList.lyric) {
        // 正则表达匹配换行符切割
        arr = this.lyricList.lyric.split(/[(\r\n)\r\n]+/).map((item, idx) => {
          // 切割获取时间数据
          let idxOfRt = item.indexOf(']'); // 右中括号的下标，为了解决处理毫秒位数不统一的问题
          let min = item.slice(1, 3); // 分
          let sec = item.slice(4, 6); // 秒
          let msec = '';
          let lrc = '';
          // 将时间转换，用来对比audio标签ref属性中的currentTime的值来确认当前播放到哪,转换为毫秒单位
          let time = parseInt(min) * 60 * 1000 + parseInt(sec) * 1000;
          if (idxOfRt != -1) {
            msec = item.slice(7, idxOfRt); // 毫秒
            lrc = item.slice(idxOfRt + 1, item.length); // 歌词;
            time += parseInt(msec);
          }
          // 返回一个数组对象
          // console.log(arr);
          return {
            min,
            sec,
            msec,
            lrc,
            time
          };
        });
        // 这里是为了拿到下一句歌词的开始时间，方便来判断当前应该显示哪一句歌词
        arr.forEach((item, i) => {
          // 如果到最后一句歌词就不需要拿下一句了,之间给最后一句的时间大一点，来保证样式在最后一句显示
          if (i === arr.length - 1 || isNaN(arr[i + 1].time)) {
            item.next = 1000000;
          } else {
            item.next = arr[i + 1].time;
          }
        });
      }
      console.log(arr);
      return arr;
    }
  },
  methods: {
    ...mapMutations(["updateDetailShow", "updatePlayListIndex"]),
    backHome() {
      this.updateDetailShow();
      this.isLyricShow = false;
    },
    // 点击进度条切换音乐播放时间
    changeBar(event) {
      // event.target.value获取进度条被点下所在的进度数据
      // 调用父组件的方法,对当前音乐时间进行修改
      this.updateAudioCtime(event.target.value);
    },
    // 上一首歌下一首歌切换
    switchSong(num) {
      let idx = this.playListIndex + num;
      // 如果为第一首并且点击了上一首按钮,就不做反应
      if (idx == -1) {
        idx = 0;
      }
      // 如果为最后一首并且点击了下一首按钮，也不反应
      if (idx >= this.playList.length) {
        idx = this.playList.length - 1;
      }
      this.updatePlayListIndex(idx);
    }
  },
  data() {
    return {
      // 控制显示歌曲的磁盘还是歌词，默认显示磁盘，不显示歌曲
      isLyricShow: false
    };
  }
};